import React from 'react';

import E_SDG_Goals from '../../images/E_SDG-goals_icons-individual-rgb-16-768x768.png';

class SDGGoalsImage extends React.PureComponent {
  render() {
    return (
      <div className={ this.props.className }>
        <img
          style={{
            width: '150px',
            height: 'auto',
            margin: '0 auto 10px',
            display: 'block'
          }}
          src={ E_SDG_Goals }
          alt={'SDG'}
        />
      </div>
    );
  }
}

export default SDGGoalsImage;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGGoalsImage.js